import { SettingOutlined } from '@ant-design/icons';

import { withNavigation } from 'containers/Navigation';

import { IRoute, Submenu } from 'types/common';

import AddUser from './AddUser'; // ✅ Import AddUser
import BannerManager from './AdManager'; // ✅ Import the new component
import Newsletter from './Newsletter';

export const routes: IRoute[] = [
  {
    component: withNavigation(AddUser), // ✅ Ensure AddUser is mapped correctly
    exact: true,
    key: 'add-user',
    path: '/newsletter/add-user',
    isPrivate: true,
  },

  {
    component: withNavigation(BannerManager),
    exact: true,
    key: 'banner-manager',
    path: '/newsletter/banners',
    isPrivate: true,
  },
  {
    component: withNavigation(Newsletter),
    exact: true,
    key: 'create-newsletter',
    path: '/newsletter/new',
    isPrivate: true,
  },
  {
    component: withNavigation(Newsletter),
    exact: true,
    key: 'newsletter',
    path: '/newsletter/:id',
    isPrivate: true,
  },
];

export const submenu: Submenu = {
  key: 'Newsletter',
  icon: SettingOutlined,
  rank: 3,
  items: [
    { key: 'banner-manager', path: '/newsletter/banners' }, // ✅ Add to submenu
    { key: 'create-newsletter', path: '/newsletter/new' },
    { key: 'add-user', path: '/newsletter/add-user' }, // ✅ Ensure this is correctly listed
  ],
};
